import styled from 'styled-components';
const ExitModalWrapper = styled.div`
.w-50{
    width:50%;
}
.invite-form-wrapper{
    >header{
        >h2{
            font-family: "Open Sans";
            font-weight: 500;
            font-size: 18px;
            color: #1f337a;
            line-height: normal;
            margin: 0px;
            padding: 30px 100px 5px 20px;
        }
        >h1{
            font-family: 'Open Sans',sans-serif;
            font-size:24px;
            font-weight: bold;
            color: #333e61;
            text-transform: capitalize;
            display: inline-block;
            margin: 0;
            padding: 10px 0 5px 20px;
        }
        >h3{
            line-height: normal;
            font-size: 12px;
            font-weight: 700;
            color: #08b2e3;
            text-transform: uppercase;
            display: block;
            margin: 0;
            padding: 0;
        }
        
    }



.button-wrapper{
    padding:20px 20px;
    .button-action{
        font-family: "open sans", sans-serif;
        cursor: pointer;
        background-color:#4eb0de;
        line-height: normal;
        margin:20px 10px 0;
        width: 129px;
        height: 26px;
        font-size: 0.75rem;
        border: 0;
        border-radius:10px;
        display: block;
        text-transform: uppercase;
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        line-height: 1;
        height: 28px;
        &:focus{
          outlie:none;
          box-shadow:none;
        }
        &.no{
            background:#4eb0de;
        }
        &.yes{
            background:#d05353;
        }
      }
    .list-item{
        margin:0 0 20px;
        &.flxbox{
            display:flex;
            justify-content:space-between;
            .col{
                flex-basis:45%;
            }
        }
        .ant-form-item-label{
            display: block;
            width: 100%;
            text-align: left;
        }
        textarea{
            height:125px;
            border:1px solid #4eb0de;
            border-radius:4px;
            resize:none;
        }
    }

    .action-pan{
        text-align:center;
        margin-top:20px;
        margin-bottom: 20px;
        .sendBtn{
            font-family: "Open Sans";
            margin-top: 20px;
            font-weight: 700;
            background: #344177;
            color: #fff;
            font-size: 14px;
            border: 1.5px solid #344177;
            border-radius: 20px;
            margin: 0 5px;
            display: inline-block;
            text-transform: uppercase;
            cursor: pointer;
            width: 180px;
            height: 40px;

        }
    }

    

.ant-modal-content{
    border-radius:10px;
}

.react-tel-input .form-control{
    border: 1px solid #4eb0de;
    border-radius: 4px;
    font-size: 16px !important;
    color: #32407b !important;
    font-weight: normal;
}
.flag-dropdown{
    background:none;
    border:none;
}
.react-tel-input .country-list .country{padding:0 10px;}
.react-tel-input .selected-flag{background:none;}
    
}


`;



export default (ExitModalWrapper);